"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_progress-bar.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MAX_WIDTH_PER_STATUS = 200;

var progressItem = function progressItem(statuses, currentStatus, index) {
  var stepClass = index < currentStatus ? 'progress-bar__step--done' : index === currentStatus ? 'progress-bar__step--active' : '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar__step ".concat(stepClass)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar__step__icon"
  }, index < currentStatus && /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "success",
    size: 10,
    color: "white",
    className: "progress-bar__step__icon__check"
  })), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    ellipsisOverflow: true,
    className: "progress-bar__step__text",
    highlighted: index === currentStatus
  }, statuses[index])), index < statuses.length - 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar__line ".concat(index >= currentStatus ? 'progress-bar__line--future' : '')
  }));
};

var ProgressBar = function ProgressBar(_ref) {
  var statuses = _ref.statuses,
      currentStatus = _ref.currentStatus;

  if (statuses.length < 2) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar",
    style: {
      maxWidth: statuses.length * MAX_WIDTH_PER_STATUS
    }
  }, statuses.map(function (item, index) {
    return progressItem(statuses, currentStatus, index);
  })));
};

var _default = ProgressBar;
exports.default = _default;